import React from 'react'
import { Box, Link, Text } from 'components'
import type { Property } from 'csstype'
import type { ResponsiveStyleValue } from '@mui/system'
import type { Theme } from '@mui/material/styles'

export type ModeItemProps = {
  title: string
  icon: React.ReactElement
  color: ResponsiveStyleValue<string[] | Property.Color> | ((theme: Theme) => ResponsiveStyleValue<string[] | Property.Color>)
  backgroundColor: ResponsiveStyleValue<string[] | Property.Color> | ((theme: Theme) => ResponsiveStyleValue<string[] | Property.Color>)
}

export const ModeItem: React.FC<ModeItemProps> = ({ title, icon, color, backgroundColor }) => {
  return <Box display="flex" alignItems="center" width="100%" sx={{ color: color, pl: 2 }}>
    <Link sx={{ color: 'inherit', backgroundColor: backgroundColor,  p: 0.5, lineHeight: '1rem', borderRadius: '10px' }}>{ icon }</Link>

    <Link pl={1} flexGrow={1} textAlign="left" ><Text fontWeight="medium">{ title }</Text></Link>
  </Box>
}

export default ModeItem
